import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import permissions from "app/permissions";
import { ActivityServicePath, SPORTS } from "utils/constants";
import { tenants } from "utils/tenants";
import ListSports from "./List";
import CreateSports from "./Create";
import EditSports from "./Edit";
import ShowSports from "./Show";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MGU],
  icon: <EmojiEventsIcon />,
  name: ActivityServicePath + SPORTS,
  title: "Спорт",
  list: <ListSports />,
  create: <CreateSports />,
  edit: <EditSports />,
  show: <ShowSports />,
  permission: permissions.canPrevieSports,
};
